<template>
  <HomeLayout>
    <b-row class="column-border-container multiple-panels">
      <b-col class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click="openMakeAPaymentModal">
          <div class="navigation-block">
            <h4 class="nav-title-center">
              MAKE A PAYMENT
            </h4>
            <div class="nav-text-center">
              <i v-if="country === 'IE'" class="icon-payments_euro vtd-icon-7" />
              <i v-else class="icon-payments_sterling vtd-icon-7" />
            </div>
          </div>
          <MakeAPayment ref="MakeAPayment" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </div>
      </b-col>

      <b-col v-if="bookingConditionsLinks.bookingTermsUrl" class="column-border col-lg card-col col-12">
        <a class="vtd-card vtd-animate-shake" @click="openBookingConditionsModal">
          <div class="vtd-card vtd-animate-shake">
            <div class="navigation-block">
              <h4 class="nav-title-center">
                BOOKING TERMS & CONDITIONS
              </h4>
              <div class="nav-text-center">
                <i class="icon-booking_conditions vtd-icon-7" />
              </div>
            </div>
            <BookingConditions ref="BookingConditionsRef" />
            <div class="vtd-card-footer nav-text-center d-none d-lg-block">
              <p class="vtd-home-btn text-center">
                View Now
              </p>
            </div>
          </div>
        </a>
      </b-col>


      <b-col class="column-border col-lg card-col col-12">
        <a class="vtd-card vtd-animate-shake" @click="openCancellationConditionsModal">
          <div class="navigation-block">
            <h4 class="nav-title-center">CANCELLATION CONDITIONS</h4>
            <div class="nav-text-center">
              <i class="icon-cancellation_conditions vtd-icon-7" />
            </div>
          </div>
          <CancellationConditions ref="CancellationConditionsRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </a>
      </b-col>

      <b-col v-if="fil === 'M'" class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click="openBalancePayHistoryModal">
          <div class="navigation-block">
            <h4 class="nav-title-center">
              PRICE &amp; PAYMENT HISTORY
            </h4>
            <div class="nav-text-center">
              <i class="icon-payment vtd-icon-7" />
            </div>
          </div>
          <BalancePayHistory ref="BalancePayHistory" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </div>
      </b-col>

      <b-col v-if="displayAtolButton && fil === 'M'" class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click="getAtolCertificate">
          <div class="vtd-card vtd-animate-shake">
            <div class="navigation-block">
              <h4 class="nav-title-center">
                ATOL CERTIFICATE
              </h4>
              <div class="nav-text-center">
                <i class="icon-atol vtd-icon-7" />
              </div>
            </div>
            <div class="vtd-card-footer nav-text-center d-none d-lg-block">
              <p class="vtd-home-btn text-center">
                View Now
              </p>
            </div>
          </div>
        </div>
        <AtolCertificate ref="AtolCertificateRef" />
      </b-col>

      <b-col v-if="summary" class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click.prevent="() => {
          $refs.LoginTokenRef.authCheckResult(() => {
            onPrinterFriendlyInvoice();
          });
        }
          ">
          <div class="navigation-block">
            <h4 class="nav-title-center">
              BOOKING INVOICE / RECEIPT
            </h4>
            <div class="nav-text-center">
              <i class="icon-booking_invoice vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
    <HomeBackBtns />
    <LoginToken ref="LoginTokenRef" />
    <PrintFriendly ref="PrintFriendlyRef" />
  </HomeLayout>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import HomeLayout from "@/partials/home-layout";
import MakeAPayment from "@/modules/navigation/modals/payment-hub/make-payment";
import BalancePayHistory from "@/modules/navigation/modals/payment-hub/balance-history";
import LoginToken from "@/modules/auth/login-token";
import CancellationConditions from "../modals/cancellation-conditions";
import BookingConditions from "../modals/booking-conditions";
import PrintFriendly from "@/modules/menu-bar/print-friendly";
import AtolCertificate from "@/modules/booking/atol-certificate/index.vue";

export default {
  components: {
    HomeLayout,
    MakeAPayment,
    BalancePayHistory,
    LoginToken,
    CancellationConditions,
    BookingConditions,
    PrintFriendly,
    AtolCertificate,
  },
  data() {
    return {
      loginRes: {}
    }
  },
  async mounted() {
    const loginOnStartRoutes = ['payment-hub-landing-auth', 'flightIssue']
    if (loginOnStartRoutes.includes(this.$route.name)) {
      this.loginRes = await this.loginOnStart({
        username: this.$route.params.surname,
        bookingNumber: this.$route.params.bookingNumber,
        source: this.$route.params.source,
      });
    }
    if (!this.loginRes) {
     return this.$router.push("/login");
    }
    if (this.$route.name === 'flightIssue') {
      // open payment modal
      this.openMakeAPaymentModal({ issueFlights: true })
    }
  },
  updated() {
    this.stopLoading()
  },
  computed: {
    ...mapGetters({
      essentialInfoMenu: "essentialInfoMenu/getMenu",
      friendFamily: "friendFamily/isFriendFamily",
      itinerary: "booking/getItinerary",
      bookingInfo: "booking/getBookingInfo",
      bookingNumber: "booking/getBookingNumber",
      accountInfo: "booking/getAccount",
      country: "booking/getCountry",
      userData: "auth/getUserData",
      fil: "booking/getFil",
      summary: "booking/hasBookingSummary"
    }),
    ...mapState({
      booking: (state) => state.booking.booking,
    }),
    bookingConditionsLinks() {
      const linksRefs = {
        bookingTermsUrl: "",
        cancellationConditionsRef: "",
        cancellationInvoiceRef: "",
      };
      const bc = this.essentialInfoMenu.find(
        (el) => el.title === "Booking Conditions"
      );
      if (bc && bc.submenu.length) {
        bc.submenu.forEach((el) => {
          if (el.title.includes("Booking Terms") && el.href) {
            linksRefs.bookingTermsUrl = el.href;
          }
          if (el.partial && el.partial === "CancellationConditionsRef") {
            linksRefs.cancellationConditionsRef = el.partial;
          }
          if (el.partial && el.partial === "CancellationInvoiceRef") {
            linksRefs.CancellationInvoiceRef = el.partial;
          }
        });
      }
      return linksRefs;
    },
    displayAtolButton() {
      return !!(this.bookingInfo &&
        this.bookingInfo.desclinks.indexOf("atol_certificate") !== -1 &&
        !this.friendFamily &&
        this.accountInfo.atol_protected === "TRUE" &&
        this.accountInfo.atol_certifno);
    },
  },
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
    }),
    openMakeAPaymentModal(options = null) {
      this.$refs.MakeAPayment.showModal(options);
    },
    openBalancePayHistoryModal() {
      this.$refs.BalancePayHistory.showModal();
    },
    openCancellationConditionsModal() {
      if (this.bookingConditionsLinks.cancellationConditionsRef) {
        this.$refs.CancellationConditionsRef.showModal();
      }
    },
    openBookingConditionsModal() {
      if (this.bookingConditionsLinks.bookingTermsUrl) {
        this.$refs.BookingConditionsRef.showModal();
      }
    },
    onPrinterFriendlyInvoice() {
      this.$refs.PrintFriendlyRef.getPrinterFriendlyInvoicePDF();
    },
    getAtolCertificate() {
      this.$refs.AtolCertificateRef.getAtolCertificate();
    },
    stopLoading() {
      this.$emit("loading-bar", false);
    }
  },
};
</script>
